import { Input as BaseInput, InputProps } from "baseui/input";
import { Theme, useTheme } from "@src/common/components/ThemeProvider/ThemeProvider";
import { useCourierLocale } from "@src/common/courierLocale";

export interface DollarInputProps extends InputProps {
  dollar: number;
  setDollar: (dollar: number) => void;
  isEmpty?: boolean;
  setEmpty?: () => void;
}

const DollarInput: React.FC<DollarInputProps> = ({
  dollar,
  setDollar,
  isEmpty = false,
  setEmpty,
  onChange,
  ...props
}) => {
  const { effectiveTheme } = useTheme();
  const { currencyDisplay } = useCourierLocale();
  return (
    <BaseInput
      startEnhancer={currencyDisplay}
      value={isEmpty ? "" : dollar.toFixed(2)}
      onChange={(event) => {
        if (onChange) {
          onChange(event);
        }
        if (event.target.value === "" && setEmpty) {
          setEmpty();
          return;
        }
        let num: number = 0.0;
        if (event.target.value) {
          const numValue = event.target.value.replace(/[^\d-]|(?!^)-/g, "");
          num = numValue === "" ? 0.0 : Number(numValue);
        }
        if (!Number.isFinite(num)) return;
        setDollar(num / 100);
      }}
      {...props}
      overrides={{
        ...props.overrides,
        Input: {
          ...props.overrides?.Input,
          style: {
            backgroundColor: effectiveTheme === Theme.DARK ? "rgb(31 41 55)" : "rgb(249 250 251)",
            colorScheme: effectiveTheme === Theme.DARK ? "dark" : "light",
            ...props.overrides?.Input?.style,
          },
        },
      }}
    />
  );
};

export default DollarInput;
